export default __webpack_public_path__ + "img/7afafb6368803a5a6e6e7cc8e641c411.png";